export const API_ENDPOINTS = {
  downloadPdf: '/health_care_applications/download_pdf',
  facilities: '/health_care_applications/facilities',
  fileUpload: '/v0/hca_attachments',
  ratingInfo: '/health_care_applications/rating_info',
};

// declare military discarge document types
export const DISCHARGE_DOC_TYPES = Object.freeze({
  1: 'DD214',
  2: 'DD215 (used to correct or make additions to the DD214)',
  3: 'WD AGO 53-55 (report of separation used prior to 1950)',
  4: 'Other discharge papers (like your DD256, DD257, or NGB22)',
  5: 'Official documentation of a military award (like a Purple Heart, Medal of Honor, or Silver Star)',
  6: 'Disability rating letter from the Veterans Benefit Administration (VBA)',
  7: 'Other official military document',
});

export const FILE_SIZE_MAX_MB = 10;
export const FILE_SIZE_MAX_BYTES = 1024 * 1024 * FILE_SIZE_MAX_MB;
export const FILE_TYPES_ACCEPTED = [
  '.doc',
  '.docx',
  '.heic',
  '.jpeg',
  '.jpg',
  '.pdf',
  '.png',
];

// declare the minimum percentage value to be considered high disability
export const HIGH_DISABILITY_MINIMUM = 50;

export const FORM_KEYS = Object.freeze({
  regOnlyEnabled: 'view:isRegOnlyEnabled',
});

export const FORM_TOGGLES = [
  {
    toggleName: 'hcaRegOnlyEnabled',
    formKey: FORM_KEYS.regOnlyEnabled,
  },
];
